import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmployeeFunctionGroupsLogicService } from './logic/employee-function-groups/employee-function-groups-logic.service';
import { EmployeeFunctionGroupsService } from './logic/employee-function-groups.service';
import { EmployeeFunctionGroupsDaoService } from './dao/employee-function-groups-dao.service';
import { EmployeeFunctionGroupsDbDaoService } from './dao/employee-function-groups-dao/employee-function-groups-db-dao.service';
import { EmployeeFunctionGroupsDbTableDefinition } from './dao/employee-function-groups-dao/employee-function-groups-db-table-definition';
import { LocalEmployeeFunctionGroupsDbTableDefinition } from './dao/employee-function-groups-dao/local-employee-function-groups-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: EmployeeFunctionGroupsService, useClass: EmployeeFunctionGroupsLogicService },
    { provide: EmployeeFunctionGroupsDaoService, useClass: EmployeeFunctionGroupsDbDaoService },
    { provide: EmployeeFunctionGroupsDbTableDefinition },
    { provide: LocalEmployeeFunctionGroupsDbTableDefinition },
  ]
})
export class EmployeeFunctionGroupsModule {}
